<template>
  <NuxtLayout name="shop">
    <template #title>
      <ShopTitle show-bio/>
    </template>

    <selling-products-list :handle="shophandle"/>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const {shophandle} = useRoute().params


const shop = await useShopData(shophandle as string)

</script>